export const Icons = ({ avatar, recipient = "", sender = "" }) => {
    return <>
    {(recipient === "Mono Bank" || sender === "Mono Bank") ?
      <i className="fas fa-university w-5 h-5"></i>
      :
      avatar ? (
        <span className="w-5 h-5">
          <i className={avatar}></i>
        </span>
      ) : (
        <i class="fa-regular fa-user w-5 h-5"></i>
      )
    }
  </>;
};

